export default [
  {
    path: "/banks",
    name: "banks",
    meta: {
      authRequired: true,
    },
    component: () => import("@/views/pages/hr-configuration/banks"),
  },
  {
    path: "/pension-providers",
    name: "pension-providers",
    meta: {
      authRequired: true,
    },
    component: () => import("@/views/pages/hr-configuration/pension-providers"),
  },
  {
    path: "/hmos",
    name: "hmos",
    meta: {
      authRequired: true,
    },
    component: () => import("@/views/pages/hr-configuration/hmos"),
  },
  {
    path: "/departments",
    name: "departments",
    meta: {
      authRequired: true,
    },
    component: () => import("@/views/pages/hr-configuration/departments"),
  },
  {
    path: "/authorization-roles",
    name: "authorization-roles",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("@/views/pages/hr-configuration/authorization-role"),
  },
  {
    path: "/grades",
    name: "grades",
    meta: {
      authRequired: true,
    },
    component: () => import("@/views/pages/hr-configuration/grades"),
  },
  {
    path: "/job-roles",
    name: "job-roles",
    meta: {
      authRequired: true,
    },
    component: () => import("@/views/pages/hr-configuration/job-roles"),
  },
  {
    path: "/states",
    name: "states",
    meta: {
      authRequired: true,
    },
    component: () => import("@/views/pages/hr-configuration/states"),
  },
  {
    path: "/local-government-areas",
    name: "Local Government Areas",
    meta: {
      authRequired: true,
    },
    component: () => import("@/views/pages/hr-configuration/lga"),
  },
  {
    path: "/country-codes",
    name: "Country Codes",
    meta: {
      authRequired: true,
    },
    component: () => import("@/views/pages/hr-configuration/country-codes"),
  },
  {
    path: "/locations",
    name: "locations",
    meta: {
      authRequired: true,
    },
    component: () => import("@/views/pages/hr-configuration/locations"),
  },
  {
    path: "/qualifications",
    name: "qualifications",
    meta: {
      authRequired: true,
    },
    component: () => import("@/views/pages/hr-configuration/qualifications"),
  },
  {
    path: "/subsidiaries",
    name: "subsidiaries",
    meta: {
      authRequired: true,
    },
    component: () => import("@/views/pages/hr-configuration/subsidiaries"),
  },
  {
    path: "/country-codes",
    name: "country-codes",
    meta: {
      authRequired: true,
    },
    component: () => import("@/views/pages/hr-configuration/country-code.vue"),
  },
  {
    path: "/public-holidays",
    name: "public-hoildays",
    meta: {
      authRequired: true,
    },
    component: () => import("@/views/pages/hr-configuration/public-holidays"),
  },
  {
    path: "/performance-improvement",
    name: "performance-improvement",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("@/views/pages/hr-configuration/performance-improvement"),
  },
  {
    path: "/public-holidays-calendar",
    name: "public-hoildays-calendar",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("@/views/pages/hr-configuration/public-holidays-calendar"),
  },
  {
    path: "/leave-types",
    name: "leave-types",
    meta: {
      authRequired: true,
    },
    component: () => import("@/views/pages/hr-configuration/leave-types"),
  },
  {
    path: "/authorization-gate-settings",
    name: "authorization-gate-settings",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("@/views/pages/hr-configuration/authorization-gate-settings"),
  },
  {
    path: "/leave-application-settings",
    redirect: "/authorization-gate-settings",
  },
  {
    path: "/ratings",
    name: "ratings",
    meta: {
      authRequired: true,
    },
    component: () => import("@/views/pages/hr-configuration/ratings"),
  },
  {
    path: "/goal-settings",
    name: "goal-settings",
    meta: {
      authRequired: true,
    },
    component: () => import("@/views/pages/hr-configuration/goal-settings"),
  },
  {
    path: "/end-of-year",
    name: "end-of-year",
    meta: {
      authRequired: true,
    },
    component: () => import("@/views/pages/hr-configuration/end-of-year"),
  },
];
